import { SlideAction, SlideLayout, ViewMode } from '@gripp/shared-ui';
import { useNavigate, useParams } from 'react-router-dom';
import { AssetCard } from './assetCard';
import { AssetComponent } from './assetComponent';
import { AssetFilters } from './assetFilters';
import { AssetsFilters } from './assetsFilters';

export const Asset = () => {
  const { assetId, '*': splat } = useParams();
  const resolvedAssetId = assetId || splat?.replace(/\/$/, '') || '';
  const navigate = useNavigate();

  const leftColumn = {
    title: 'assets.menu.title',
    mainComponent: <AssetComponent />,
    headerComponent: <AssetsFilters />,
    disableScroll: true,
  };

  const rightColumn = {
    title: 'assets.menu.title',
    mainComponent: <AssetCard assetId={resolvedAssetId} />,
    headerComponent: <AssetFilters assetId={resolvedAssetId} />,
    showBackButton: true,
    backButtonTransition: SlideAction.SINGLE,
    onBackButtonPress: () => {
      navigate('/assets');
    },
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};
